<template>
	<div>
		<font-awesome-icon
			v-if="importing_locations"
			size="2x"
			icon="spinner"
			pulse
			style="color:white"
		/>
		<div v-else>
			<CustomButton
				text="Import locations"
				:inverse="true"
				previous_icon="arrow-down"
				onclick="document.getElementById('import_locations_input').click()"
			/>
			<input
				id="import_locations_input"
				type="file"
				ref="file"
				style="display: none"
				accept=".csv"
				v-on:change="handle_file_upload()"
			/>
		</div>
	</div>
</template>

<script>
import CustomButton from "@/components/sub-components/CustomButton";
import LocationsExportImportService from "@/services/LocationsExportImportService";
import ForecastService from "@/services/ForecastService";

export default {
	name: "ImportButton",
	components: {
		CustomButton
	},
	props: ["error_callback"],
	data: function() {
		return {
			importing_locations: undefined
		};
	},
	methods: {
		async handle_file_upload() {
			var file = this.$refs.file.files[0];
			var csv_content = await file.text();

			this.importing_locations = true;

			try {
				//Get locations from csv
				var imported_locations = LocationsExportImportService.convert_csv_loations(
					csv_content
				);
			} catch (e) {
				this.error_callback(e.message);
				this.importing_locations = undefined;
				return;
			}

			try {
				//Download locations forecasts
				var promises = [];
				imported_locations.forEach(location => {
					promises.push(
						ForecastService.get_location_forecasts(location).then(data => {
							location.forecasts = data;
							this.$store.commit("add_location", location);
						})
					);
				});

				await Promise.all(promises);
			} catch (e) {
				this.error_callback("Error downloading some forecasts");
			} finally {
				this.importing_locations = undefined;
			}
		}
	}
};
</script>

<style></style>
